var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTorsoInner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main_icons",
    "data-name": "Main icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m4,6.39h3c.55,0,1-.45,1-1v-2.97l4.46,4.46c.39.39,1.02.39,1.41,0l2.12-2.12L11.54.29c-.39-.39-1.02-.39-1.41,0l-2.12,2.12v-.03h-4L0,6.39v8.56c0,.55.45,1,1,1h3V6.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24,28H8v-10.95c0-.55-.45-1-1-1h-3v14.95c0,.55.45,1,1,1h22c.55,0,1-.45,1-1v-14.95h-3c-.55,0-1,.45-1,1v10.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.54,6.88l4.46-4.46-2.12-2.12c-.39-.39-1.02-.39-1.41,0l-4.46,4.46,2.12,2.12c.39.39,1.02.39,1.41,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28,2.39h-4v3c0,.55.45,1,1,1h3v9.56h3c.55,0,1-.45,1-1V6.39l-4-4Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorsoInner);
export default __webpack_public_path__ + "static/media/torsoInner.cccb7aa9b30a2ee741ec881e30c0a951.svg";
export { ForwardRef as ReactComponent };